import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { oneMonthBeforeToday } from "App/utils/helpers";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import {
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENGADAAN,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_SELESAI,
} from "../PurchaseOrder/helpers";
import React from "react";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = LIST_URL_WAREHOUSE.purchaseOrderLGS.get;
export const urlDelete = LIST_URL_WAREHOUSE.purchaseOrderLGS.delete;

export const RESET_STATE_FORM_FILTER = {
  id: "",
  pages: 1,
  limit: 10,
  supplier_id: "",
  pembelian_id: "",
  gudang_id: "",
  status_transaksi: "",
  status_name: "Semua",
  nomorPO: "",
  jumlah: 10,
  offset: 2,
  halaman: 1,
  gudang: "Pilih Gudang",
  supplier: "Pilih Supplier",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: moment(new Date()).local().toDate(),
};

export const statusTransaksi = [
  {
    value: "",
    label: "Semua",
  },
  {
    value: 1,
    label: "Draft",
  },
  {
    value: 2,
    label: "Di Setujui",
  },
  {
    value: 3,
    label: "Pengadaan",
  },
  {
    value: 4,
    label: "Selesai",
  },
];

export const getByFilterPO = async (
  formFilter,
  pages,
  limit,
  pembelian_id = 1
) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      pembelian_id: formFilter.id,
      nomorPO: formFilter.nomorPO,
      status_transaksi: pembelian_id === 0 ? "2" : formFilter.status_transaksi,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
      offset: pages - 1,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePoById = async (id) => {
  try {
    const api = await instance4.get(`${urlDelete}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus po",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "pembelian_id",
    disablePadding: false,
    label: "PEMBELIAN ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nomorPO",
    disablePadding: false,
    label: "NOMOR PO",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "suplier",
    disablePadding: false,
    label: "SUPPLIER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_transaksi",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "processedBy",
    disablePadding: false,
    label: "DIPROSES OLEH",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "total_harga",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusPoBadge = ({ status }) => {
  if (status === STATUS_TRANSAKSI_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Draft"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_DISETUJUI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Process"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENGADAAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Pengadaan"}
        color={"lightgreen"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Selesai"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan</p>;
  }
};
